import { capitalize } from 'common/utils/string';
import { useFormState } from 'components/elements/form';
import useActivityColumn from 'components/elements/table/editable-columns/activity-column';
import deleteColumn from 'components/elements/table/editable-columns/delete-column';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import { ActivitySalesGuestDetailFormType } from '../../form-type';

export default function useGetGuestDetailTableList(
  isGroupedPrice: boolean,
): IColumn<ActivitySalesGuestDetailFormType>[] {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const activityColumn = useActivityColumn();

  const columns = React.useMemo<IColumn<ActivitySalesGuestDetailFormType>[]>(
    () => [
      {
        header: t('common:other'),
        accessorKey: 'activityId',
        minSize: 250,
        maxSize: 250,
        dataType: ColumnDataType.select,

        selectProps: activityColumn,
        required: true,
      },
      {
        header: t('common:type'),
        accessorKey: 'type',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.null,
        disabled: true,
        cell: ({ getValue }) => capitalize(getValue() as string),
      },
      {
        header: t('common:date'),
        accessorKey: 'date',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.date,
      },
      {
        header: t('common:price'),
        accessorKey: 'price',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t(isGroupedPrice ? 'common:total_qty' : 'common:qty'),
        accessorKey: 'qty',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        required: true,
      },
      {
        header: t('common:total_price'),
        accessorKey: 'totalPrice',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.number,
        minNumber: 0,
        disabled: true,
      },
      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 150,
        maxSize: 150,
        dataType: ColumnDataType.text,
      },
      ...deleteColumn(editable),
    ],
    [activityColumn, editable, isGroupedPrice, t],
  );

  return columns;
}
